// Basic
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// Store & actions
import actionsPosTerminals from '../../../api/actionsPosTerminals';
// Compoents
import Entity from '@/common-utils/components/renders/entity/Entity';
import HeaderTitle from '@/common-utils/components/renders/modal/components/headers/HeaderTitle/HeaderTitle';
import OpenStreetMapComponent from '../../../../../../common-utils/components/renders/openStreetMap/OpenStreetMapComponent';
import FooterClose from '@/common-utils/components/renders/modal/components/footers/FooterClose/FooterClose';
import { Modal, ModalBody, ModalContent } from '@/common-utils/components/ui/modal';
import { Skeleton } from '@/common-utils/components/ui/skeleton';
// Common
import COUNTRY_CODE_FLAGS from '@/common-utils/enums/countryCodeFlags';
// Lang
import { nsTerminal } from '@/app/i18n/namespaces';

/**
 * @param root0
 * @param root0.isOpen
 * @param root0.setIsOpen
 * @param root0.posTerminalUuid
 * @param root0.ipAddress
 * @returns ModalGeolocation
 */
function ModalGeolocation({ isOpen, setIsOpen, posTerminalUuid, ipAddress }) {

    // State
    const [apiError, setApiError] = useState(false);
    const [latitude, setLatitude] = useState(undefined);
    const [longitude, setLongitude] = useState(undefined);
    const [flag, setFlag] = useState(undefined);

    // API Call
    const { data, isError, isLoading } = actionsPosTerminals.getGeolocation(posTerminalUuid);

    // Hooks
    useEffect(() => {
        if (isError) {
            setApiError(true);
        } else if (data) {
            setLatitude(parseFloat(data.lat));
            setLongitude(parseFloat(data.lon));
            setFlag(COUNTRY_CODE_FLAGS[data.countryCode]);
        }
    }, [data, isError]);

    return (
        <Modal open={isOpen} onOpenChange={setIsOpen}>
            <ModalContent className='max-w-lg'>
                <HeaderTitle title={'modal.geolocation.title'} namespace={nsTerminal} />
                <ModalBody className='text-center'>
                    {
                        isLoading ?
                            <div className='mb-4 space-y-4'>
                                <div className='flex flex-col gap-4 justify-center items-center'>
                                    <Skeleton className='w-48 h-4 text-center animate-pulse rounded-md' />
                                    <Skeleton className='w-64 h-4 text-center justify-center animate-pulse rounded-md' />
                                    <Skeleton className='w-72 h-4 text-center justify-center animate-pulse rounded-md' />
                                </div>
                                <Skeleton className='w-full h-80 animate-pulse rounded-md' />
                            </div>
                            :
                            data && Number.isFinite(latitude) && Number.isFinite(longitude) ?
                                <div className='space-y-1'>
                                    <div className='text-base break-words whitespace-normal'>
                                        {ipAddress}
                                    </div>
                                    <div className='text-base break-words whitespace-normal'>
                                        {[data.isp, data.org].filter(Boolean).join(', ')}
                                    </div>
                                    <div className='text-lg break-words whitespace-normal'>
                                        {`
                                                        ${data.city ? `${data.city}, ` : ''}
                                                        ${data.region ? `${data.region}, ` : ''}
                                                        ${data.country ? `${data.country} ` : ''}
                                                        ${data.countryCode ? `${flag}` : ''}
                                                        `}
                                    </div>
                                    <div className='border border-black'>
                                        <OpenStreetMapComponent
                                            center={{
                                                lat: latitude,
                                                lng: longitude
                                            }}
                                        />
                                    </div>
                                    <small><Entity entity='modal.geolocation.informations' namespace={nsTerminal} /></small>
                                </div>
                                : apiError ?
                                    <div>{ }
                                        {ipAddress}<br />
                                        <Entity entity='modal.geolocation.error.api' namespace={nsTerminal} />
                                    </div>
                                    :
                                    <div>
                                        {ipAddress}<br />
                                        <Entity entity='modal.geolocation.not_found' namespace={nsTerminal} />
                                    </div>
                    }
                </ModalBody>
                <FooterClose />
            </ModalContent>
        </Modal>
    );
}

ModalGeolocation.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    setIsOpen: PropTypes.func.isRequired,
    ipAddress: PropTypes.string,
    posTerminalUuid: PropTypes.string
};

export default ModalGeolocation;